import { QuestionTypes, ResponseTypes } from 'bundles/survey-form/constants/SurveyFormConstants';

export const ONBOARDING_SURVEY_BASE_ID = 'afUpDK-8TR-tghPy38a67w';
export const ONBOARDING_SURVEY_VERSION = 9;

export const QUESTION_RESPONSE_TYPE_MAP = {
  [QuestionTypes.MULTIPLE_CHOICE]: ResponseTypes.MULTIPLE_CHOICE_RESPONSE,
  [QuestionTypes.CHECKBOX]: ResponseTypes.CHECKBOX_RESPONSE,
  [QuestionTypes.SHORT_ANSWER]: ResponseTypes.SHORT_ANSWER_RESPONSE,
  [QuestionTypes.NUMERIC]: ResponseTypes.NUMERIC_RESPONSE,
  [QuestionTypes.PARAGRAPH_ANSWER]: ResponseTypes.PARAGRAPH_ANSWER_RESPONSE,
  [QuestionTypes.SINGLE_CHECKBOX]: ResponseTypes.SINGLE_CHECKBOX_RESPONSE,
  [QuestionTypes.TYPEAHEAD]: ResponseTypes.TYPEAHEAD_RESPONSE,
  [QuestionTypes.DROPDOWN]: ResponseTypes.DROPDOWN_RESPONSE,
};
